// Stripe product/price mapping for Mindmail subscription tiers
export const SUBSCRIPTION_TIERS = {
  monthly: {
    product_id: "prod_U4z6WMs6CbHb8q",
    price_id: "price_1T6p81KjVRUxPDH2fMK9skXU",
    name: "Monthly Plan",
    price: "$14.99",
    period: "per month",
  },
  quarterly: {
    product_id: "prod_U4z6xJwKm1iVCp",
    price_id: "price_1T6p8LKjVRUxPDH2HIofG39C",
    name: "Quarterly Plan",
    price: "$39.99",
    period: "every 3 months",
  },
  yearly: {
    product_id: "prod_U4z6kObS2mwwut",
    price_id: "price_1T6p8eKjVRUxPDH228WkIfb6",
    name: "Annual Plan",
    price: "$149.99",
    period: "per year",
  },
} as const;

export type SubscriptionTier = keyof typeof SUBSCRIPTION_TIERS;

export function getTierByProductId(productId: string): SubscriptionTier | null {
  for (const [key, tier] of Object.entries(SUBSCRIPTION_TIERS)) {
    if (tier.product_id === productId) return key as SubscriptionTier;
  }
  return null;
}
